(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bk-sticky-buy"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-bk-sticky-buy]').forEach((bar) => {
    const section = bar.closest('.shopify-section') || document;
    const mainButton = section.querySelector('[id^="BuyButtons-ProductSubmitButton"]');

    if (!mainButton) {
      bar.hidden = false;
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          bar.hidden = entry.isIntersecting;
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(mainButton);
  });
  } catch(e) { console.error(e); }
})();

})();
